import LsdApiModel from './global/LsdApiModel';

export default class ProjectCategoryStatsModel extends LsdApiModel {
	static get path(): string {
		return '/project_categories/stats?projectPole={?projectPole}&expenseGroup={?expenseGroup}';
	}
}
